(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zava-gift-vouchers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.zv-gv').forEach(function (root) {
    // Amount → card preview
    var out = root.querySelector('[data-zv-gv-amount]');
    var inputs = root.querySelectorAll('input[data-zv-gv-label]');
    function showAmount(input) { if (out) out.textContent = input.getAttribute('data-zv-gv-label'); }
    inputs.forEach(function (input) {
      input.addEventListener('change', function () { showAmount(input); });
    });
    var checked = root.querySelector('input[data-zv-gv-label]:checked');
    if (checked) showAmount(checked);

    // Me / them → enable the native recipient properties only when "them"
    var panel = root.querySelector('[data-zv-gv-recipient]');
    if (!panel) return;
    var controls = panel.querySelectorAll('input, textarea');
    var required = panel.querySelector('[data-zv-gv-required]');
    var offset = panel.querySelector('[data-zv-gv-offset]');
    var sendOn = panel.querySelector('[data-zv-gv-send-on]');
    if (sendOn) sendOn.min = new Date().toISOString().slice(0, 10);

    function setMode(toThem) {
      panel.hidden = !toThem;
      controls.forEach(function (c) { c.disabled = !toThem; });
      if (required) required.required = toThem;
      if (offset) offset.value = toThem ? String(new Date().getTimezoneOffset()) : '';
      previewAll();
    }
    root.querySelectorAll('[data-zv-gv-deliver]').forEach(function (r) {
      r.addEventListener('change', function () { setMode(r.value === 'recipient'); });
    });

    // Name / message → card preview
    var previews = {};
    root.querySelectorAll('[data-zv-gv-preview]').forEach(function (el) {
      previews[el.getAttribute('data-zv-gv-preview')] = { el: el, blank: el.textContent };
    });
    function preview(key, value) {
      var p = previews[key];
      if (!p) return;
      var v = (value || '').trim();
      p.el.textContent = v || p.blank;
      p.el.classList.toggle('is-filled', !!v);
    }
    function previewAll() {
      panel.querySelectorAll('[data-zv-gv-field]').forEach(function (f) {
        preview(f.getAttribute('data-zv-gv-field'), panel.hidden ? '' : f.value);
      });
    }
    panel.querySelectorAll('[data-zv-gv-field]').forEach(function (f) {
      f.addEventListener('input', previewAll);
    });

    var initial = root.querySelector('[data-zv-gv-deliver]:checked');
    setMode(!!initial && initial.value === 'recipient');
  });

  } catch(e) { console.error(e); }
})();
})();
